import React, { useState } from "react";
import { connect } from "socket.io-client";
import { userHasRole } from "../../utils";

export const WhatsAppContext = React.createContext([]);

export function WhatsAppCtxProvider({ children }) {
  // - States
  const [isLoading, setIsLoading] = useState(false);
  const [operator, setOperator] = useState(false);
  const [qrCodeHTML, setQrCodeHTML] = useState(false);
  const [waChatList, setWaChatList] = useState([]);;
  const [waContactsList, setWaContactsList] = useState([]);
  const [waData, setWaData] = useState({
    currentChatId: false,
    currentChatMessages: []
  });
  const [wsState, setWsState] = useState({
    isWsServerConnected: false,
    isAuthenticated: false,
    state: false
  })
  // - Refs
  const websocketInstance = React.useRef(false);
  const websocketHeartBeat = React.useRef(false);

  /**
   * @name initMerchantWhatsapp
   * @description Aguarda carregar informações do lojista
   * para iniciar conexão com servidor Socket.IO
   */
  const initMerchantWhatsapp = async () => {
    if (isLoading)
      return;

    setIsLoading(true);
    let userProfileResponse = window._sessionData;
    if (userProfileResponse) {
      setOperator({
        operator_id: userProfileResponse.oldUserId,
        company_id: userProfileResponse.businessId,
        branch_id: false,
        roles: []
      });
    }
    setIsLoading(false);
  }

  /**
   * @name handleWhatsappWsConnection
   * @description Inicia conexão com servidor Socket.IO
   */
  const handleWhatsappWsConnection = () => {
    if (wsState.isWsServerConnected) {
        websocketInstance.current.emit('data', {
            cmd: 'init',
            payload: {
              operator_id: operator.operator_id,
              company_id: operator.company_id,
              branch_id: operator.branch_id,
              roles: operator.roles,
            }
        });
        
        const newData = {
          ...waData,
          currentChatId: false,
          currentChatMessages: [  ]
        };
        
        localStorage.setItem('waChatList', JSON.stringify([]));
        localStorage.setItem('waContactsList', JSON.stringify([]));
        localStorage.setItem('waContactsList', JSON.stringify(newData));

        setWaChatList([]);
        setWaContactsList([]);
        setWaData(newData)
    }

    if (websocketInstance.current || !operator)
      return;
    
    websocketInstance.current = connect("https://whatsapp-api.clinicasajustar.com.br", {
    //websocketInstance.current = connect("http://127.0.0.1:23232", {
        reconnection: true,
        transports: ["websocket"],
        pingInterval: 25000,
        pingTimeout: 5000
    });

    websocketInstance.current.on("connect", () => {
        console.log('[OnBeefWhatsapp:WEBSOCKET] Successfully connected to Ajustar WhatsApp API. operator:');
        websocketInstance.current.emit('data', {
            cmd: 'init',
            payload: {
              operator_id: operator.operator_id,
              company_id: operator.company_id,
              branch_id: operator.branch_id,
              roles: operator.roles,
            }
        });
        websocketPing();
    });
  
    websocketInstance.current.on("connect_error", (error) => {
        console.log('[OnBeefWhatsapp:WEBSOCKET] connect_error', 'ERROR');
        console.log(error, 'ERROR');
        websocketInstance.current.connect();
    });
      
    websocketInstance.current.on("disconnect", (reason) => {
        console.log('[OnBeefWhatsapp:WEBSOCKET] Socket closed/disconnected!! trying to reconnect in 5 seconds.', 'ERROR');
        console.log(reason, 'ERROR');
        clearInterval(websocketHeartBeat.current);
        websocketHeartBeat.current = false;
        setTimeout(() => {
          if (websocketInstance.current !== false) {
            websocketInstance.current.connect();
          }
        }, 5000);
    });
  
    websocketInstance.current.on('data', (data) => { handleWebsocketData(data) });
  
    websocketInstance.current.on('error', (error) => {
        console.log('[OnBeefWhatsapp:WEBSOCKET] error', 'ERROR');
        console.log(error, 'ERROR');
    });
  }

  /**
   * @name handleWebsocketData
   * @description Função responsável por processar
   * mensagens recebidas do servidor Socket.IO da OnBeef
   */
  const handleWebsocketData = (message) => {
    console.log(message.cmd ? message.cmd : message.error, 'handleWebsocketData:', message.payload);

    if (message.error) {

    } else {
      switch(message.cmd) {
        case 'connected': {
          $('#react-container').unblock();
          if (message.data.state === 'open') {
            setQrCodeHTML(false);
            setWsState({
              ...wsState,
              isWsServerConnected: true,
              isAuthenticated : true,
              whatsAppInstanceState: message.data
            });
            if (userHasRole('ADMIN') || userHasRole('SUPERVISOR')) {
                websocketInstance.current.emit('data', {
                    cmd: 'fetchChats',
                    payload: {
                        operator_id: operator.operator_id,
                        company_id: operator.company_id,
                        branch_id: message.branch_id,
                        roles: operator.roles,
                    }
                })
                websocketInstance.current.emit('data', {
                    cmd: 'fetchContacts',
                    payload: {
                        operator_id: operator.operator_id,
                        company_id: operator.company_id,
                        branch_id: message.branch_id,
                        roles: operator.roles,
                    }
                })
            }
          } else {
            setWsState({
              ...wsState,
              isWsServerConnected: true,
              whatsAppInstanceState: message.data
            });
          }
          break;
        }
        case 'setQrCode': {
          setQrCodeHTML(message.payload.qrCode.base64);
          break;
        }
        case 'setChatList': {
          const payloadArrayOfObjects = Object.keys(message.payload.data).map(key => ({
            key: key,
            ...message.payload.data[key]
          }));
          setWaChatList([...payloadArrayOfObjects]);
          localStorage.setItem('waChatList', JSON.stringify([...payloadArrayOfObjects]));
          break;
        }
        case 'setContactsList': {
          const payloadArrayOfObjects = Object.keys(message.payload.data).map(key => ({
            key: key,
            ...message.payload.data[key]
          }));
          setWaContactsList([...payloadArrayOfObjects])
          localStorage.setItem('waContactsList', JSON.stringify([...payloadArrayOfObjects]));
          break;
        }
        case 'setCurrentChatMessages': {
          $('#react-container').unblock();
          const newData = {
            ...waData,
            currentChatId: message.payload.chat_id,
            currentChatMessages: [ ...message.payload.data ]
          };
          setWaData(newData)
          localStorage.setItem('waData', JSON.stringify(newData));
          break;
        }
        case 'updateCurrentChatMessages': {
          $('#react-container').unblock();
          const storedWaData = localStorage.getItem('waData');
          if (!storedWaData)
            return;
          const oldData = JSON.parse(storedWaData);
          const newData = {
            ...waData,
            currentChatId: message.payload.chat_id,
            currentChatMessages: [ ...message.payload.data, ...oldData.currentChatMessages ]
          };
          setWaData(newData)
          localStorage.setItem('waData', JSON.stringify(newData));
          break;
        }
        // - Webhooks recebidos
        case 'webhook': {
          let webhookPayload = message.payload.data;
          switch(message.payload.event) {
            case 'qrcode.updated': {
              if (webhookPayload) {
                if (webhookPayload?.['message']) {
                  setQrCodeHTML(false);
                } else {
                  setQrCodeHTML(webhookPayload.qrcode.base64)
                }
              }
              break;
            }
            case 'connection.update': {
              if (message.payload.data.state === 'open') {
                setQrCodeHTML(false);
                setWsState({
                  ...wsState,
                  isWsServerConnected: true,
                  isAuthenticated : true,
                  whatsAppInstanceState: message.payload.data
                });
              } else {
                if (message.payload.data.state === 'close') {
                  setQrCodeHTML(false);
                }
                setWsState({
                  ...wsState,
                  isWsServerConnected: true,
                  isAuthenticated : false,
                  whatsAppInstanceState: message.payload.data
                });
              }
              break;
            }

            // - Mensagens
            case 'messages.set':
            case 'messages.upsert': 
            case 'messages.update':
            case 'send.message': {
              const storedWaData = localStorage.getItem('waData');
              if (!storedWaData)
                return;
              const oldData = JSON.parse(storedWaData);
              if (!message.payload.data.key) {
                return console.log('RECEIVED MESSAGE ACKNOWLEGMENT', message.payload.data)
              }
              if (message.payload.data.key.remoteJid === oldData.currentChatId) {
                const newData = {
                  ...waData,
                  currentChatId: oldData.currentChatId,
                  currentChatMessages: [ ...oldData.currentChatMessages, message.payload.data ]
                };
                setWaData(newData)
                localStorage.setItem('waData', JSON.stringify(newData));
              }
              break;
            }

            // - Chats
            case 'chats.set': {
              const payloadArrayOfObjects = Object.keys(message.payload.data).map(key => ({
                key: key,
                ...message.payload.data[key]
              }));
              const newData = [ ...payloadArrayOfObjects, ...waChatList ];
              setWaChatList(newData);
              localStorage.setItem('waChatList', JSON.stringify(newData));
              break;
            }
            case 'chats.upsert':  // Apenas 1 chat por vez
            case 'chats.update': { // Apenas 1 chat por vez
              const storedChatList = localStorage.getItem('waChatList');
              if (!storedChatList)
                return;
              let oldData = JSON.parse(storedChatList);
              let newData = Array.from(message.payload.data)[0];

              // Remove chat que recebeu atualização de mensagem
              // da lista de chats
              for (let i in oldData) {
                  let chat = oldData[i];
                  if (chat) {
                      if (chat.id === newData.id) {
                        // TODO: Este delete causa criação de pontos nulos dentro da array
                        // da lista de chats do usuário, seria bom botar um filter em chaves nulas
                        // para salvar apenas os chats corretamente
                        delete oldData[i];
                      }
                  }
              }

              // Adiciona chat que recebeu atualização no início da lista...
              const finalNewData = [newData, ...oldData];
              setWaChatList(finalNewData);
              localStorage.setItem('waChatList', JSON.stringify(finalNewData));
              break;
            }

            // - Contatos
            case 'contacts.set': {
              const payloadArrayOfObjects = Object.keys(message.payload.data).map(key => ({
                key: key,
                ...message.payload.data[key]
              }));

              const newData = [ ...payloadArrayOfObjects, ...waContactsList ];
              setWaContactsList(newData);
              localStorage.setItem('waContactsList', JSON.stringify(newData));
              break;
            }
            case 'contacts.upsert':
            case 'contacts.update': { // Apenas 1 contato por vez
              const storedContactsList = localStorage.getItem('waContactsList');
              let oldData = JSON.parse(storedContactsList);
              let newData = Array.from(message.payload.data);

              // Remove duplicates based on the 'id' field
              for(let x in newData) {
                let found = false;

                // Remove duplicates based on the 'id' field
                for (let i in oldData) {
                  let contact = oldData[i];
                  if (contact) {
                    if (contact.id === newData[x].id) {
                      oldData[i].id = newData[x].id;
                      oldData[i].owner = newData[x].owner;
                      oldData[i].profilePictureUrl = newData[x].profilePictureUrl;
                      if (newData[x].pushName) {
                          oldData[i].pushName = newData[x].pushName;
                      }
                      found = true;
                    }
                  }
                }

                if (!found) {
                  if (!Array.isArray(oldData))
                    oldData = [];
                  oldData.push(newData[x]);
                }
              }

              const finalNewData = oldData;
              setWaContactsList(finalNewData);
              localStorage.setItem('waContactsList', JSON.stringify(finalNewData));
              break;
            }
            default: {
              break;
            }
          }
          break;
        }
        default: {
          break;
        }
      }
    }
  }

  /**
   * @name websocketPing
   * @description Função responsável por emitir um comando de ping
   * para o servidor Socket.IO da OnBeef
   */
  const websocketPing = () => {
    if (websocketHeartBeat.current !== false) {
      clearInterval(websocketHeartBeat.current);
      websocketHeartBeat.current = false;
    }

    websocketHeartBeat.current = setInterval(function() {
      if (websocketInstance.current === false) {
        clearInterval(websocketHeartBeat.current);
        websocketHeartBeat.current = false;
        return;
      }
      websocketInstance.current.emit("ping");
    }, 25000);
  }

  /**
   * @name getQrCode
   * @returns Emite um comando para o servidor Socket.IO da OnBeef
   * requisitando um qrcode da instância de whatsapp.
   */
  const getQrCode = () => {
    if (!websocketInstance.current)
      return;

    websocketInstance.current.emit('data', {
      cmd: 'getQrCode',
      payload: {
        operator_id: operator.operator_id,
        company_id: operator.company_id,
        branch_id: operator.branch_id,
        roles: operator.roles,
      }
    })
  }

  React.useEffect(() => {
    if (window._sessionData) {
        initMerchantWhatsapp();
    }
  }, [window._sessionData]);

  // Efeito usado unicamente ao carregar e fechar a página
  React.useEffect(() => {
    return () => {
      clearInterval(websocketHeartBeat.current);
      if (websocketInstance.current)
        websocketInstance.current.close();
    }
  }, []);

  // Efeito usado ao carregar aplicação para resgatar informações do lojista
  React.useEffect(() => {
    if (operator)
      if (operator.branch_id)
        handleWhatsappWsConnection();
      else {
        clearInterval(websocketHeartBeat.current);
        if (websocketInstance.current)
            websocketInstance.current.close();
      }
  }, [operator]);

  // Carrega waChatList do localStorage para persistência dos dados
  React.useEffect(() => {
    const storedChatList = localStorage.getItem('waChatList');
    if (storedChatList) {
      setWaChatList(JSON.parse(storedChatList));
    }
  }, []);

  // Carrega waContactsList do localStorage para persistência dos dados
  React.useEffect(() => {
    const storedContactsList = localStorage.getItem('waContactsList');
    if (storedContactsList) {
      setWaContactsList(JSON.parse(storedContactsList));
    }
  }, []);

  // Carrega waData do localStorage para persistência dos dados
  React.useEffect(() => {
    const storedWaData = localStorage.getItem('waData');
    if (storedWaData) {
      setWaData(JSON.parse(storedWaData));
    }
  }, []);

  // Atualiza o estado de waChatList no localStorage
  React.useEffect(() => {
    localStorage.setItem('waChatList', JSON.stringify(waChatList));
  }, [waChatList]);

  // Atualiza o estado de waContactsList no localStorage
  React.useEffect(() => {
    localStorage.setItem('waContactsList', JSON.stringify(waContactsList));
  }, [waContactsList]);

  // Atualiza o estado de waData no localStorage
  React.useEffect(() => {
    localStorage.setItem('waData', JSON.stringify(waData));
  }, [waData]);

  return (
    <WhatsAppContext.Provider
      value={{
        isLoading,
        operator,
        websocketInstance,
        wsState,
        waChatList,
        waContactsList,
        waData,
        qrCodeHTML,
        getQrCode,
        setOperator,
        setWaData
      }}
    >
      {children}
    </WhatsAppContext.Provider>
  );
}